module.exports = __webpack_public_path__ + "img/pinzhongzhuizong_head.7c2eb1aa.png";